import CollapsableCard from "../../../components/CollapseableCard";
import LineItem from "../../../components/NewDetail/views/OrderTabs/Invoice/LineItem";
import LineItemInput from "../../../components/NewDetail/views/OrderTabs/Invoice/LineItemInput";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useEditInvoiceForOrder from "../../../hooks/useEditInvoiceForOrder";
import {
  Button,
  Box,
  Typography,
  Link,
  ListItem,
  ListItemText,
  FormHelperText,
  Card,
  TextField,
  MenuItem,
  Fab,
  Checkbox,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import QbCustomers from "../../../components/NewDetail/views/OrderTabs/Invoice/QbCustomers";
import { toTwoDecimals } from "../../../components/NewDetail/calculations/utils";
import ExistingInvoices from "../../../components/NewDetail/views/OrderTabs/Invoice/ExistingInvoices";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import SelectPaymentMethod from "./SelectPaymentMethod";
import SelectDepositAccount from "./SelectDepositAccount";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import {
  DatePicker,
  DesktopTimePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment-timezone";
import InvoicePayment from "./InvoicePayment";
import OrderTitle from "../../../components/OrderTitle";

const ReceiveCashOrCheckPayment = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { openSnackMessage } = useContext(SnackAlertContext);
  const [order, setOrder] = useState(null);
  const {
    lineItems,
    addLineItem,
    newLineItem,
    handleNewLineItemChange,
    serviceOptions,
    submitInvoice,
    removeLineItem,
    isSubmitting,
  } = useEditInvoiceForOrder(orderId);
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [invoiceLink, setInvoiceLink] = useState("");
  const [invoice, setInvoice] = useState(null);
  const [qbCustomerId, setQbCustomerId] = useState(null);
  const [paymentDate, setPaymentDate] = useState(moment());
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentReferenceNumber, setPaymentReferenceNumber] = useState(null);
  const [paymentDepositAccount, setPaymentDepositAccount] = useState(false);
  const [relatedInvoices, setRelatedInvoices] = useState([]);
  const [paymentLines, setPaymentLines] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [depositAccounts, setDepositAccounts] = useState([]);

  const getOrderById = async (id) => {
    try {
      // setLoading(true);
      // REMOVE ID from Default Variables because we're just copying the values
      // This object is added to pieces if their variable property is null

      const response = await ezorder.get(`/admin/orders/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      // console.log("API Response: ", response.data.order);
      if (response.status === 200 || response.status == 201) {
        setOrder(response.data.order);
      }
    } catch (error) {
      console.log(error);
      //   setError(error);
    } finally {
      setLoading(false);
    }
  };

  const createInvoiceBody = (qbCustomerId, lineItems) => {
    const items = lineItems.map((item) => ({
      DetailType: "SalesItemLineDetail",
      Amount: parseFloat(parseFloat(item.amount).toFixed(1)),
      Description: item.description,
      SalesItemLineDetail: {
        Qty: parseFloat(parseFloat(item.qty).toFixed(1)),
        ServiceDate: moment(item.serviceDate).format(),
        ItemRef: {
          name: item.service.Name,
          value: item.service.Id,
        },
        TaxCodeRef: {
          value: item.isTaxed ? "TAX" : "NON",
        },
      },
    }));
    return { Line: [...items], CustomerRef: { value: `${qbCustomerId}` } };
  };

  const handleSubmit = () => {
    const invoiceData = createInvoiceBody(qbCustomerId, lineItems);
    let body = {
      invoiceData,
      orderId: order.id,
    };
    console.log(body);
    submitInvoice(body);
  };

  const getInvoiceDetails = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(
        `/admin/orders/${order.id}/invoice`,
        data
      );

      setInvoice(response.data.invoice);
      setInvoiceLink(response.data.invoice.InvoiceLink);
      let mainInvoiceBalance = Number(response.data.invoice.Balance);
      setPaymentLines([
        {
          ...response.data.invoice,
          amountApplied: mainInvoiceBalance,
        },
      ]);
      setPaymentAmount(mainInvoiceBalance);
    } catch (error) {
      console.log("Failed To Load Invoice for Order", order.id);
    } finally {
      setLoading(false);
    }
  };

  // let paymentObject = {
  //     TxnDate: paymentDate,
  //     TotalAmt,
  //     PaymentMethodRef: {
  //       value: paymentMethod.Id,
  //     },
  //     PaymentRefNum: paymentReferenceNumber ?? "",
  //     DepositToAccountRef: {
  //       value: paymentDepositAccount.Id,
  //     },
  //     Line: [
  //       {
  //         Amount: Number(paymentAmount),
  //         LinkedTxn: [
  //           {
  //             TxnId: `${invoiceId}`, // Invoice ID
  //             TxnType: "Invoice",
  //           },
  //         ],
  //       },
  //     ],
  //   };
  const handlePayment = async () => {
    try {
      setLoading(true);
      // TODO: check that payment lines added up is equal or greater than amount received
      const response = await ezorder.post(
        `/quickbooks/invoice/${order.invoiceId}/payments`,
        {
          paymentData: {
            paymentDate,
            paymentAmount,
            paymentMethod,
            paymentReferenceNumber,
            paymentDepositAccount,
            paymentLines,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status == 200 || response.status == 201) {
        console.log(response);
        openSnackMessage("success", "Payment received!");
        // window.location.reload(false);
        navigate(-1);
      } else {
        console.log(response);
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const getPaymentMethods = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/quickbooks/payment-methods`, data);

      setPaymentMethods(response.data.paymentMethods);
    } catch (error) {
      console.log("Failed To Load Payment Methods");
    } finally {
      setLoading(false);
    }
  };
  const getDepositAccounts = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/quickbooks/accounts`, data);

      setDepositAccounts(response.data.accounts);
    } catch (error) {
      console.log("Failed To Load Payment Methods");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaymentMethods();
    getDepositAccounts();
  }, []);

  const getAllRelatedInvoicesByCustomer = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(
        `/quickbooks/invoice/${order.invoiceId}/related`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      console.log(response);
      setRelatedInvoices(response.data.invoices);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (order && order.invoiceId) getAllRelatedInvoicesByCustomer();
  }, [order]);

  useEffect(() => {
    // console.log("OrderTableRow useEffect()");
    const controller = new AbortController();
    if (order && order.invoiceId) {
      getInvoiceDetails(controller);
    }

    return () => {
      controller.abort(); // abort api call on unmount for cleanup
    };
  }, [order]);

  useEffect(() => {
    getOrderById(orderId);
  }, [orderId]);

  if (!order) return null;

  if (order && order.invoiceId && order.invoiceCustomerRefName) {
    return (
      <Box sx={{ paddingBottom: "200px" }}>
        <Box sx={{ flex: 1 }}>
          <OrderTitle order={order} includeStatus={true} />
        </Box>
        <Typography variant="h5" sx={{ textAlign: "center" }}>
          Receive Invoice Payment
        </Typography>
        <Box sx={{ padding: "16px" }}>
          {invoice ? (
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Box sx={{ minWidth: "300px" }}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Primary Invoice Details
                </Typography>
                Subcustomer:{" "}
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={invoice.InvoiceLink}
                >
                  {invoice.CustomerRef.name}
                </Link>
                <Typography>Invoice #{invoice.DocNumber}</Typography>
                <Typography>Invoice Date: {invoice.TxnDate}</Typography>
                <Typography>Due Date: {invoice.DueDate}</Typography>
                <Typography>
                  Balance: ${toTwoDecimals(invoice.Balance)}
                </Typography>
                <Typography>Email Status: {invoice.EmailStatus}</Typography>
                <Typography>Bill Email: {invoice.BillEmail.Address}</Typography>
              </Box>
              {invoice.BillAddr && (
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    Billing Address
                  </Typography>
                  <Typography>{invoice.BillAddr.Line1}</Typography>
                  <Typography>{invoice.BillAddr.Line2}</Typography>
                  <Typography>
                    {invoice.BillAddr.City},{" "}
                    {invoice.BillAddr.CountrySubDivisionCode}{" "}
                    {invoice.BillAddr.PostalCode}
                  </Typography>
                </Box>
              )}
            </Box>
          ) : (
            <>
              <Typography>
                Could not find invoice details on quickbooks. Please check that
                this invoice was not voided or deleted on Quickbooks
              </Typography>
              Link <a href={invoiceLink}>{order.invoiceCustomerRefName}</a>
            </>
          )}
        </Box>

        <Box sx={{}}>
          <Box sx={{ paddingTop: "16px" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={{ marginRight: "10px", marginBottom: "15px" }}
                format="MM/DD/YYYY"
                label="Date"
                value={paymentDate}
                onChange={(newValue) => {
                  setPaymentDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField fullWidth sx={{}} {...params} />
                )}
              />
            </LocalizationProvider>
            <TextField
              sx={{ marginTop: "16px" }}
              label="Amount Received"
              type="number"
              fullWidth
              value={paymentAmount}
              onChange={(e) => {
                setPaymentAmount(e.target.value);
              }}
            />
            <Box sx={{ marginTop: "16px" }}>
              <SelectPaymentMethod
                onSelect={(paymentMethod) => {
                  setPaymentMethod(paymentMethod);
                }}
              />
            </Box>
            <TextField
              sx={{ marginTop: "16px" }}
              label="Reference no. (Check # for a Check, envelop # for a cash donation)"
              fullWidth
              value={paymentReferenceNumber}
              onChange={(e) => {
                setPaymentReferenceNumber(e.target.value);
              }}
            />
            <Box sx={{ marginTop: "16px" }}>
              <SelectDepositAccount
                onSelect={(account) => {
                  setPaymentDepositAccount(account);
                }}
              />
            </Box>
            <Typography sx={{ marginTop: "16px", fontWeight: "bold" }}>
              Apply Payment To Customer's Invoice(s)
            </Typography>
            <TableContainer sx={{ maxHeight: "400px", marginTop: "16px" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "50px" }}></TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Original Amount</TableCell>
                    <TableCell>Current Balance</TableCell>
                    <TableCell>Due Date</TableCell>
                    <TableCell>Apply Payment</TableCell>
                  </TableRow>
                </TableHead>
                {paymentLines &&
                  paymentLines.map((line, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell sx={{ width: "50px" }}>
                          <Checkbox
                            style={{
                              magin: 0,
                              padding: 0,
                            }}
                            checked={true}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                let paymentLinesCopy = [...paymentLines];
                                paymentLinesCopy.splice(index, 1);
                                setPaymentLines(paymentLinesCopy);
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == order.invoiceId ? "bold" : "inherit",
                          }}
                        >
                          Invoice #{line.DocNumber}
                          {" - "}
                          {line.CustomerRef.name ==
                          line.CustomerRef.parentRefName
                            ? line.CustomerRef.name
                            : `${line.CustomerRef.parentRefName} - ${line.CustomerRef.name}`}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == order.invoiceId ? "bold" : "inherit",
                          }}
                        >
                          ${invoice.TotalAmt}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == order.invoiceId ? "bold" : "inherit",
                          }}
                        >
                          ${line.Balance}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == order.invoiceId ? "bold" : "inherit",
                          }}
                        >
                          {line
                            ? `${moment(line.DueDate).format("MM/DD/YY")}`
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == order.invoiceId ? "bold" : "inherit",
                          }}
                        >
                          <TextField
                            label="Payment"
                            type="number"
                            value={line.amountApplied}
                            onChange={(e) => {
                              let paymentLinesCopy = [...paymentLines];
                              paymentLinesCopy[index].amountApplied =
                                e.target.value ?? Number(e.target.value);
                              setPaymentLines(paymentLinesCopy);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {relatedInvoices &&
                  relatedInvoices.map((invoice, index) => {
                    if (
                      !paymentLines.find(
                        (paymentLine) => paymentLine.Id == invoice.Id
                      )
                    ) {
                      return (
                        <TableRow key={index}>
                          <TableCell sx={{ width: "50px" }}>
                            <Checkbox
                              style={{
                                magin: 0,
                                padding: 0,
                              }}
                              checked={
                                paymentLines.find(
                                  (paymentLine) => paymentLine.Id == invoice.Id
                                )
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  let paymentLinesCopy = [...paymentLines];
                                  setPaymentLines([
                                    ...paymentLinesCopy,
                                    { ...invoice, amountApplied: 0 },
                                  ]);
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight:
                                invoice.Id == order.invoiceId
                                  ? "bold"
                                  : "inherit",
                            }}
                          >
                            Invoice #{invoice.DocNumber}
                            {" - "}
                            {invoice.CustomerRef.name ==
                            invoice.CustomerRef.parentRefName
                              ? invoice.CustomerRef.name
                              : `${invoice.CustomerRef.parentRefName} - ${invoice.CustomerRef.name}`}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontWeight:
                                invoice.Id == order.invoiceId
                                  ? "bold"
                                  : "inherit",
                            }}
                          >
                            ${invoice.TotalAmt}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight:
                                invoice.Id == order.invoiceId
                                  ? "bold"
                                  : "inherit",
                            }}
                          >
                            ${invoice.Balance}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight:
                                invoice.Id == order.invoiceId
                                  ? "bold"
                                  : "inherit",
                            }}
                          >
                            {invoice
                              ? `${moment(invoice.DueDate).format("MM/DD/YY")}`
                              : "N/A"}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })}
              </Table>
            </TableContainer>
            <Box>
              <Typography variant="h6" sx={{ textAlign: "right" }}>
                Total Applied $
                {paymentLines &&
                  paymentLines.reduce(
                    (accumulator, paymentLine) =>
                      accumulator + Number(paymentLine.amountApplied ?? 0),
                    0
                  )}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: "16px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <LoadingButton
            sx={{ width: "170px", marginRight: "16px" }}
            size="large"
            variant="outlined"
            loading={loading}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            sx={{ width: "170px" }}
            size="large"
            color="success"
            variant="contained"
            loading={loading}
            onClick={() => {
              handlePayment();
            }}
          >
            Save Payment
          </LoadingButton>
        </Box>
      </Box>
    );
  }
};
export default ReceiveCashOrCheckPayment;
